import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const InformationBadgeWrapper = styled.div`
  .activity-info {
    min-width: 200px;
    background-color: ${COLORS.cirrus_orange_light};
    border: 1px solid ${COLORS.cirrus_orange_dark};
    border-radius: 8px;
    margin: 16px;
    padding: 16px;
    color: ${COLORS.cirrus_black};
  }
  ${responsive.MOBILE`
    .activity-info {
      margin: 0 16px 16px 16px;
    }
  `}
`;
